import { useEffect, useState } from 'react';
import { detectMode } from '../services/networkMode';

// Esse hook só serve para sugerir ao usuário que ele *pode* logar online.
export function useCmdServerWatcher() {
  const [isCmdOnline, setIsCmdOnline] = useState(null);
  const [shouldSuggestOnlineLogin, setShouldSuggestOnlineLogin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const authMode = sessionStorage.getItem('authMode') || 'offline';
      const nodeRedOnlineUrl = sessionStorage.getItem('nodeRedOnlineUrl');
      const hasEverBeenOnline = sessionStorage.getItem('hasEverBeenOnline') === 'true';

      // Só faz sentido checar CMD-server se:
      // - estamos em sessão offline
      // - ainda não temos URL do Node-RED online
      //   (ou seja, nunca completamos login online nessa máquina)
      if (authMode !== 'offline' || hasEverBeenOnline || nodeRedOnlineUrl) {
        return;
      }

      const mode = await detectMode(); // usa /health do CMD_SERVER

      if (cancelled) return;

      const onlineNow = mode === 'online';

      if (onlineNow && !isCmdOnline) {
        // acabou de ficar online
        setIsCmdOnline(true);
        setShouldSuggestOnlineLogin(true);
      } else if (!onlineNow && isCmdOnline) {
        // caiu de novo
        setIsCmdOnline(false);
        setShouldSuggestOnlineLogin(false);
      }
    }

    check();
    const id = setInterval(check, 10000); // a cada 10s, ajusta se quiser

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [isCmdOnline]);

  const clearCmdOnlineSuggestion = () => setShouldSuggestOnlineLogin(false);

  return { isCmdOnline, shouldSuggestOnlineLogin, clearCmdOnlineSuggestion };
}